
      if (typeof __webpack_require__ !== "undefined") {
        var originalGet = __webpack_require__.u;
        var originalEnsure = __webpack_require__.e;
        var queryMap = {};
        var countMap = {};
        __webpack_require__.u = function(chunkId) {
          var result = originalGet(chunkId);
          return result + (queryMap.hasOwnProperty(chunkId) ? '?' + queryMap[chunkId] : '');
        };
        __webpack_require__.e = function(chunkId) {
          var result = originalEnsure(chunkId);
          return result.catch(function(error) {
            var retries = countMap.hasOwnProperty(chunkId) ? countMap[chunkId] : 10;
            if (retries < 1) {
              error.message = 'Loading chunk ' + chunkId + ' failed after 10 retries.';
			  
              throw error;
            }
            return new Promise(function(resolve) {
              var retryAttempt = 10 - retries + 1;
              setTimeout(function() {
                var retryAttemptString = '&r=' + retryAttempt;
                var cacheBust = "";
                var query = cacheBust + retryAttemptString;
                queryMap[chunkId] = query;
                countMap[chunkId] = retries - 1;
                resolve(__webpack_require__.e(chunkId));
              }, 4000);
            });
          });
        };
      }
        